export default __webpack_public_path__ + "static/media/renfest_logo.52d72b08.png";